import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Title = styled.div`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 700;
  color: #0a1437;
  white-space: break-spaces;
  text-align: center;

  ${responsiveFontSize(20, 1)};

  ${mediaQuery('tablet', 'min')} {
    min-height: 75px;
  }
`;

export const Card = styled.div<{ bg: string; bgColor: string }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 16px 24px;
  height: 100%;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  background-image: ${(props) => `url(${props.bg})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${(props) => `${props.bgColor}`};

  ${mediaQuery('small')} {
    padding: 8px 24px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;
  text-align: center;
  ${mediaQuery('medium')} {
    margin-bottom: 6px;
  }
`;
